module.exports = __webpack_public_path__ + "fonts/Minecrafter.dbb580fc.eot";